module.exports = __webpack_public_path__ + "a42f7dc523c99b60b8d3e46234811244.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/folder_add_2x.png
// module id = 113
// module chunks = 0 1 2 3 4